import * as actionTypes from './actionTypes';

export const axiosPayLoad = {
  drugsList: [],
  drugsModalList: [],
  searchValue: {},
  searchTable: {
    labeler: [],
    drugName: [],
    ndcs: [],
    ndcsLeft: [],
    ndcsRight: [],
    manufacturer: [],
    manufacturers: [],
    ndcsFilter: null,
    nameFilter: null,
    listFor: null,
    list: [],
  },
  ndcsList: {
    ndcsLeft: [],
    ndcsRight: [],
  },
  ndcsListForModal: {
    ndcsLeft: [],
    ndcsRight: [],
  },
  errorMessages: {
    serachPage: [],
    detailPage: [],
    detailTablePage: [],
  },
  extraState: {
    fullScreenView: {
      ndcLeftList: false,
      ndcRightList: false,
      labeler: false,
      tableName: null,
      ndcDetail: false,
      refExNDCList: false,
    },
    showViewHistory: false,
    edit: false,
    isCancel: false,
    ndcInputErr: false,
    callLebelerAPI: false,
    clearNDCLeft: false,
    searchValueChange: false,
    serachValForModal: false,
    oldSearchVal: null,
  },
  dropdown: [],
  allManufacturer: [],
  allLabeler: [],
  ndcsHistory: [],
  ndcsDetailList: [],
  filterAndSort: [],
  saveNDC: null,
  existingNDCOriginalList: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_NDCs_LIST_SEARCH_BY_NAME_OR_NDCs:
      return { ...state, drugsList: action.drugsList, saveNDC: null };
    case actionTypes.GET_NDCs_LIST_MODAL_SEARCH_BY_NAME_OR_NDCs:
      return { ...state, drugsModalList: action.drugsModalList, saveNDC: null };
    case actionTypes.GET_EXCLUDED_NDC_SEARCH:
      return { ...state, searchValue: action.searchValue, saveNDC: null };
    case actionTypes.GET_COMMON_DROPDOWN_DATA:
      return { ...state, dropdown: action.dropdown, saveNDC: null };
    case actionTypes.GET_ALL_MANUFATURERE_LIST:
      return {
        ...state,
        allManufacturer: action.allManufacturer,
        saveNDC: null,
      };
    case actionTypes.GET_ALL_LABELER_LIST:
      return { ...state, allLabeler: action.allLabeler, saveNDC: null };
    case actionTypes.GET_NDCS_LIST_BY_MANUFACTURERS:
      return { ...state, ndcsDetailList: action.ndcsDetailList, saveNDC: null };
    case actionTypes.UPDATE_NDCS_LIST_VALUE_UNDER_AG_GRID:
      return {
        ...state,
        ndcsDetailList: {
          ...state.ndcsDetailList,
          updatedList: action.ndcsDetailList,
        },
        saveNDC: null,
      };
    case actionTypes.SAVE_EXCLUDED_NDC:
      return { ...state, saveNDC: action.saveNDC };
    case actionTypes.VIEW_HISTORY:
      return { ...state, ndcsHistory: action.ndcsHistory };
    case actionTypes.SEARCH_TABLE_ACTION:
      return { ...state, searchTable: action.searchTable, saveNDC: null };
    case actionTypes.SEARCH_TABLE_NDCS_LIST:
      const result = { ...action.ndcsList };
      const leftNdcList = [];
      const rightNdcList = [];
      if (result?.ndcsLeft?.length > 0) {
        result.ndcsLeft.forEach((item) => {
          if (
            leftNdcList?.length === 0 ||
            leftNdcList?.filter((x) => {
              return x.drugSeqNum === item.drugSeqNum;
            })?.length === 0
          ) {
            leftNdcList.push(item);
          }
        });
        result.ndcsLeft = leftNdcList;
      }
      if (result?.ndcsRight?.length > 0) {
        result.ndcsRight.forEach((item) => {
          if (
            rightNdcList?.length === 0 ||
            rightNdcList?.filter((x) => {
              return x.drugSeqNum === item.drugSeqNum;
            })?.length === 0
          ) {
            rightNdcList.push(item);
          }
        });
        result.ndcsRight = rightNdcList;
      }
      return { ...state, ndcsList: result, saveNDC: null };
    case actionTypes.MODAL_SEARCH_TABLE_NDCS_LIST:
      const result1 = { ...action.ndcsListForModal };
      const leftNdcList1 = [];
      const rightNdcList1 = [];
      if (result?.ndcsLeft?.length > 0) {
        result.ndcsLeft.forEach((item) => {
          if (
            leftNdcList1?.length === 0 ||
            leftNdcList1?.filter((x) => {
              return x.drugSeqNum === item.drugSeqNum;
            })?.length === 0
          ) {
            leftNdcList1.push(item);
          }
        });
        result.ndcsLeft = leftNdcList1;
      }
      if (result?.ndcsRight?.length > 0) {
        result.ndcsRight.forEach((item) => {
          if (
            rightNdcList1?.length === 0 ||
            rightNdcList1?.filter((x) => {
              return x.drugSeqNum === item.drugSeqNum;
            })?.length === 0
          ) {
            rightNdcList1.push(item);
          }
        });
        result.ndcsRight = rightNdcList1;
      }
      return {
        ...state,
        ndcsListForModal: result1,
        saveNDC: null,
      };
    case actionTypes.EXCLUDED_NDCS_ERROR_MSG:
      return { ...state, errorMessages: action.errorMessages, saveNDC: null };
    case actionTypes.EXCLUDED_NDCS_EXTRA_STATE:
      return { ...state, extraState: action.extraState };
    case actionTypes.FILTER_AND_SORT_FOR_EXCLUDED_NDC:
      return {
        ...state,
        filterAndSort: { ...state.filterAndSort, ...action.payload },
      };
    case actionTypes.CLEAR_EXCLUDED_NDCS_REDUX_DATA:
      return action.payload ? action.payload : { ...axiosPayLoad };
    case actionTypes.EXISTING_NDC_LIST:
      return {
        ...state,
        existingNDCOriginalList: action.existingNDCOriginalList,
      };
    default:
      return state;
  }
};

export default reducer;
